// extracted by mini-css-extract-plugin
export default {"social":"Footer_social__MfQNF","logoFooter":"Footer_logoFooter__lP2b6"};